import React from 'react';
import { FormsEmailContainer } from '../../components/forms/FormEditContainer';

const FormDetailPage: React.FC = () => {
  return <FormsEmailContainer />;
};

export default FormDetailPage;
